/* La Perse â€” PDP Qty Stepper
   Clamp 1..99, keep hidden input in sync. */
(function () {
  'use strict';

  document.querySelectorAll('[data-qty]').forEach(function (root) {
    var input = root.querySelector('[data-qty-input]');
    var dec = root.querySelector('[data-qty-decrement]');
    var inc = root.querySelector('[data-qty-increment]');
    if (!input) return;

    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;

    function clamp(v) {
      v = parseInt(v, 10);
      if (isNaN(v)) v = min;
      if (v < min) v = min;
      if (v > max) v = max;
      return v;
    }

    function set(v) {
      input.value = clamp(v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (dec) dec.addEventListener('click', function () { set(parseInt(input.value, 10) - 1); });
    if (inc) inc.addEventListener('click', function () { set(parseInt(input.value, 10) + 1); });
    input.addEventListener('blur', function () { set(input.value); });
  });
})();